/* eslint-disable jsx-a11y/media-has-caption */
import { Trash } from 'iconsax-react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import player from '../../assets/images/play.svg';
import Midia from '../Midia';
import * as styles from './styles';

export default function CustomMidia({
  midia = null,
  onDel = null,
  icon = true,
  isImg = null,
  total = 0,
  index = 0,
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  function handleShow() {
    const newParams = new URLSearchParams(window.location.search);
    newParams.set('media', index);
    setSearchParams(newParams);
  }

  function handleClose() {
    const newParams = new URLSearchParams(window.location.search);
    newParams.delete('media');
    setSearchParams(newParams);
  }

  const mediaIndex = searchParams.get('media');
  const isActive = parseInt(mediaIndex, 10) === index;

  return (
    <styles.Wrapper
      className="custom-midia"
      onClick={onDel ? null : handleShow}
    >
      {onDel && (
        <styles.Button onClick={onDel}>
          <Trash />
        </styles.Button>
      )}

      {isImg ? (
        <img src={midia?.url} alt="Upload da modelo" />
      ) : (
        <>
          <video src={midia?.url} />
          <styles.IconPlayer>
            <img src={player} alt="player" />
          </styles.IconPlayer>
        </>
      )}

      <Midia
        show={isActive}
        onClose={handleClose}
        midia={midia}
        icon={icon}
        total={total}
        index={index}
        isImg={isImg}
      />
    </styles.Wrapper>
  );
}

CustomMidia.propTypes = {
  midia: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onDel: PropTypes.func,
  icon: PropTypes.bool,
  isImg: PropTypes.bool,
  index: PropTypes.number,
  total: PropTypes.number,
};
